import React from 'react';

export const SERIES_COLORS = [
    '#3b82f6', // blue-500
    '#10b981', // emerald-500
    '#ec4899', // pink-500
    '#f59e0b', // amber-500
    '#8b5cf6', // violet-500
    '#06b6d4', // cyan-500
    '#ef4444', // red-500
    '#14b8a6', // teal-500
    '#f43f5e', // rose-500
    '#a855f7', // purple-500
    '#6366f1', // indigo-500
    '#eab308', // yellow-500
    '#84cc16', // lime-500
    '#22c55e', // green-500
    '#ff7849', // orange
    '#ffc82c'  // gold
];

export const STRATEGY_LABELS = [
    'Optimus Nifty',
    'Optimus Banknifty',
    'Optimus Finnifty',
    'Optimus Midcapnifty',
    'Optimus Sensex',
    'Pledge+ CRUDEOIL',
    'Pledge+ SILVER',
    'Pledge+ GOLD',
    'Pledge+ NATURALGAS',
    'Pledge+ COPPER',
    'Pledge+ ZINC',
    'Pledge+ LEAD',
    'Pledge+ ALUMINIUM',
    'Pledge+ MENTHAOIL',
    'Commodity Options CRUDEOIL',
    'Commodity Options SILVER',
    'Commodity Options GOLD',
    'Commodity Options NATURALGAS',
    'Commodity Options COPPER',
    'Commodity Options ZINC',
    'Commodity Options LEAD',
    'Commodity Options ALUMINIUM',
    'Commodity Options MENTHAOIL',
    'Commodity Options COTTON',
    'SGX GIFT NIFTY',
    'Other',
];

export const FMT_PCT = (val) => {
    if (val === null || val === undefined) return <span className="text-gray-600">-</span>;
    const n = Number(val);
    const color = n >= 0 ? 'text-emerald-400' : 'text-red-400';
    return <span className={`font-mono font-semibold ${color}`}>{n >= 0 ? '+' : ''}{n.toFixed(2)}%</span>;
};

export const FMT_RANGE = (min, max) => {
    if (min === null && max === null) return <span className="text-gray-600">-</span>;
    const lo = min !== null ? Number(min).toFixed(1) : '?';
    const hi = max !== null ? Number(max).toFixed(1) : '?';
    const color = parseFloat(lo) >= 0 ? 'text-blue-300' : 'text-orange-300';
    return <span className={`font-mono text-xs ${color}`}>{lo}% <span className="text-gray-500">to</span> {hi}%</span>;
};

export const FMT_DATETIME_SHORT = (val) => {
    if (!val) return '-';
    const d = new Date(val);
    const datePart = d.toLocaleDateString([], { month: 'short', day: 'numeric' });
    const timePart = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    return `${datePart} ${timePart}`;
};

export const FMT_DATETIME_IST = (val) => {
    if (!val) return '-';
    try {
        const d = new Date(val);
        if (isNaN(d.getTime())) return val;
        return d.toLocaleString('en-US', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    } catch (e) {
        return val;
    }
};

export const FMT_TIME_NAIVE = (val) => {
    if (!val) return '-';
    try {
        const naiveStr = typeof val === 'string' ? val.split(/[+-](?=\d{2}:\d{2}$)/)[0].replace(/Z$/, '') : val;
        const d = new Date(naiveStr);
        if (isNaN(d.getTime())) return val;
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    } catch (e) {
        return val;
    }
};

export const getLabelStyles = (label) => {
    const l = label?.toLowerCase() || "";
    if (l.includes("clearmind")) {
        return "bg-purple-500/20 text-purple-400 border border-purple-500/30";
    } else if (l.includes("og")) {
        return "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30";
    } else if (l.includes("satyam")) {
        return "bg-amber-500/20 text-amber-400 border border-amber-500/30";
    }
    return "bg-blue-500/20 text-blue-400 border border-blue-500/30";
};
